// extracted by mini-css-extract-plugin
module.exports = {"land-area":"c6e8ba5398--land-area--1d8sU"};